import * as yup from "yup";


export const sectionValidationSchema = yup.object({
  label: yup.string().required("Veuillez saisir le libelle"),
  // holder: yup.mixed().required("Veillez choisir le porteur du projet"),
  // initiator: yup.mixed().required("Veillez choisir l'initiateur du projet"),
  // direction: yup.mixed().required("Veillez saisir le nom du projet"),
  // startDate: yup.date().required("Veillez choisir la date de lancement souhaité"),
  // targetClient: yup.string().required("Veillez indiquer la cible"),
  // sendToART: yup.boolean(),
  // origin: yup.string(),
  // goal: yup.string(),
  // reason: yup.string(),
  // description: yup.string(),
  // priority: yup.string().required("Veillez choisir la priorité du projet"),
});
